import { SliceCaseReducers } from "@reduxjs/toolkit";
import CreateGenericSlice from "../GenericSlice";
import { ListAppointmentCardInterface } from "../../Interfaces/AppointmentCardInterface";
import {
  ListPenImageInterface,
  PenImageInterface,
} from "../../Interfaces/ListPenImageInterface";

const store = CreateGenericSlice<
  ListPenImageInterface,
  SliceCaseReducers<ListPenImageInterface>
>({
  name: "PenImages",
  initialState: { items: [] }, // Ensure items is initialized as an array
  reducers: {
    insertPenImg: (state, { payload }: { payload: PenImageInterface }) => {
      state.items = [...(state.items || [])];
      const existingPenIndex = state.items.findIndex(
        (pen) => pen.recordId === payload.recordId
      );

      if (existingPenIndex !== -1) {
        // If the pen with the same recordId already exists, update it
        state.items[existingPenIndex].penImg = payload.penImg;
      } else {
        // If the pen with the recordId doesn't exist, insert it
        state.items!.push(payload);
      }
    },
    insertPenFile: (state, { payload }: { payload: PenImageInterface }) => {
      const existingPenIndex = state.items.findIndex(
        (pen) => pen.recordId === payload.recordId
      );

      if (existingPenIndex !== -1) {
        // If the pen with the same recordId already exists, update it
        state.items[existingPenIndex].penFile = payload.penFile;
      } else {
        // If the pen with the recordId doesn't exist, insert it
        state.items.push(payload);
      }
    },
    clearData: (state) => {
      state.items = [];
    },
  },
});

export const { insertPenImg, insertPenFile, clearData } = store.actions;

export default store.reducer;
